import ListingRestrictions from 'listings/scripts/listing_restrictions'

$(function () {
  ListingRestrictions.init()
})
